import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import thunk from "redux-thunk";

// all reducers
import authReducer from './features/authHandler.feature';
import servicesReducer from './features/services.feature';
import paidJobsReducer from './features/paidjobs.features';

const reducers = combineReducers({
  auth: authReducer,
  services: servicesReducer,
  paidJobs: paidJobsReducer
});
const persistConfig = {
  key: '3bids',
  storage,
  whitelist: ['auth', 'services'],
};
const persistedReducer = persistReducer(persistConfig, reducers);


export default configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});